import { render, staticRenderFns } from "./new-region-form.vue?vue&type=template&id=b6d30820&"
import script from "./new-region-form.vue?vue&type=script&lang=js&"
export * from "./new-region-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports